/**
 * Implement API calls to the fwa sendgrid subscribe bouncer microservice
 * found at subscribe-api.myfwa.com
 */
import isDebug from '../debug-flag.js'

/**
 * Returns a promose that resolves to the body of an API response.
 * Throws an error if api request is unsuccessful
 * @email E-Mail address to be subscribed
 * @listIds Array of sendgrid list_id to be 
 */
async function fwaSubscribe_p (email, listIds) {
  if (isDebug) { console.log(`sendgridSubscribe_p ${email} ${listIds}`) }

  // simple validation listids exists
  if ( !Array.isArray(listIds) || !(listIds.length > 0) ) {
    throw new Error('listIds parameter must contain an array of sendgrid list_id for subscription')
  }

  // simple validation of email address format
  if ( !email.match(/^.+@.+\..+$/) ) {
    throw new Error('Not a valid Email address')
  }

  // Build api call
  const url = isDebug ? 'http://localhost:3000/subscribe' : 'https://subscribe-api.myfwa.com/subscribe'
  // const url = 'http://localhost:3000/subscribe'
  // const url = 'https://subscribe-api.myfwa.com/subscribe'
  let requestOpts = {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      email,
      lists: listIds,
    }),
  }

  // Execute api call
  return fetch( url, requestOpts )
  .then((response) => {
    if ( isDebug ) {
      console.log({
        request: { ...requestOpts, url },
        response,
      })
    }

    if ( response.status >= 200 && response.status <= 299 ) {
      return response.json()
    } else {
      console.error(response)
      throw new Error(`API request to ${url} failed!`)
    }
  })
}

export { fwaSubscribe_p }
